import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	align-items: center;
	padding: 24px;
	border-radius: 6px;
	background-color: ${tokens.color_gray_light};

	& > button {
		display: flex;
		gap: 10px;
		font-size: 16px;
		font-weight: 600;
	}
`;

export const TrafficLights = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 20px;
`;
